import styled from 'shared/utils/styled';

export const LedgerAccountEventItem = styled('li')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 5,
  '&:last-child': {
    marginBottom: 0,
  },
}));

export const LedgerAccountEventText = styled('span')(() => ({
  marginRight: 7,
  fontSize: 14,
  color: '#6e6e6e',
  '&:nth-child(2)': {
    flex: 1,
  },
  '&:last-child': {
    marginRight: 0,
  },
}));
